import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, useLocation } from 'react-router-dom';

import { handleOpenMenu, handleOpenMenuMobile } from '../../entities/ComponentsSlice';
import { flatsLocalStorageSelector } from '../../entities/FavoriteFlatSlice';
import { deviceSelector } from '../../entities/UserSlice';
import ROUTES from '../../layout/routes';
import DropDownFlats from './components/DropDownFlats';
import DropDownStandartBlock from './components/DropDownStandartBlock';
import DropDownVisual from './components/DropDownVisual';
import style from './HeaderButtons.module.scss';
import { useIconWrapperStyle } from './hooks/useHeaderColorScheme ';
import { useMatchedRoute } from './hooks/useMatchedRoute';

const HeaderButtons = ({ headerColorScheme, visual }) => {
  const flatfavorites = useSelector(flatsLocalStorageSelector);
  const device = useSelector(deviceSelector);
  const dispatch = useDispatch();
  const headBarIconWrapperStyle = useIconWrapperStyle(headerColorScheme);
  const location = useLocation();
  const match = useMatchedRoute();
  const deviceMobileMenuClose = () => {
    device !== 'isMobile' ? dispatch(handleOpenMenu(false)) : dispatch(handleOpenMenuMobile(false));
  };

  const dropDownSelect = () => {
    if (['visual', 'floor', 'house', 'bulk'].includes(match)) {
      return <DropDownVisual onClick={deviceMobileMenuClose} />;
    }
    if (location.pathname.includes(ROUTES.flats.list)) {
      return <DropDownFlats onClick={deviceMobileMenuClose} />;
    }
    return <DropDownStandartBlock onClick={deviceMobileMenuClose} />;
  };

  useEffect(() => {}, []);
  return (
    <div className={style.headerBar__select}>
      <NavLink className={style.link} to={ROUTES.favorites.root}>
        <div onClick={deviceMobileMenuClose} className={headBarIconWrapperStyle} role='button' tabIndex='0'>
          <div className={style.headerBar__heart}>
            <svg width='16' height='15' viewBox='0 0 16 15' fill='none'>
              <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M3.61848 0.503437C2.11498 0.72228 1.06589 1.42978 0.467229 2.62856C0.0191351 3.52581 -0.126021 4.83965 0.116573 5.8025C0.351854 6.7364 0.915854 7.76431 1.78567 8.84447C2.85923 10.1776 4.51707 11.7232 6.38182 13.1295C6.69789 13.3678 7.82501 14.1695 7.9527 14.2467C7.99748 14.2738 8.22589 14.1202 9.0537 13.506C11.3382 11.8112 13.2994 9.95959 14.4987 8.3655C15.6288 6.86344 16.0956 5.60615 15.9628 4.42256C15.7071 2.14462 13.8386 0.457061 11.5693 0.454593C10.4036 0.453311 9.34001 0.889968 8.4912 1.71831C8.36229 1.84412 8.20057 2.01831 8.13182 2.10544C8.06307 2.19256 7.99979 2.26384 7.9912 2.26384C7.9826 2.26384 7.91932 2.19256 7.85057 2.10544C7.30913 1.41934 6.42448 0.835905 5.56804 0.60003C5.04748 0.456655 4.22117 0.415718 3.61848 0.503437Z'
                fill='#1C1C1C'
              />
            </svg>
          </div>
          {flatfavorites?.length !== 0 && (
            <div className={style.headerBar__iconwrapper__favor}>{flatfavorites?.length}</div>
          )}
        </div>
      </NavLink>
      {!visual && dropDownSelect()}
    </div>
  );
};

export default HeaderButtons;
